import {
	CHECK_CONNECTION_FAILURE,
	CHECK_CONNECTION_SUCCESS,
	SERVER_CONFIG_BY_RESTAURANT_REQUEST,
	SERVER_CONFIG_BY_RESTAURANT_SUCCESS,
} from 'new-constants/api.constants';
import {SET_CURRENT_RESTAURANT} from 'new-constants/app-state.constants';
import {AppStateState} from './app-state.reducer.types';
import {SET_CURRENT_RESTAURANT_FROM_CART, START} from '../constants/app-state.constants';
import {REPEAT_ORDER_SUCCESS} from '../constants/api.constants';

const initialState: AppStateState = {
	isAppStarted: false,
	isOnline: null, //TODO remove in favor of Connectivity.reducer
	appId: null,
	restaurantId: null,
	customSplash: null,
};

export const appStateReducer = (previousState = initialState, action): AppStateState => {
	switch (action && action.type) {
		case START:
			return {
				...previousState,
				isAppStarted: true,
				restaurantId: action.returnFromAdyen
					? action.returnFromAdyen.restaurantId
					: previousState.restaurantId,
			};
			break;
		case CHECK_CONNECTION_SUCCESS:
			return {
				...previousState,
				isOnline: true,
			};
			break;

		case CHECK_CONNECTION_FAILURE:
			return {
				...previousState,
				isOnline: false,
			};
			break;

		case SERVER_CONFIG_BY_RESTAURANT_REQUEST:
			return {
				...previousState,
				appId: null,
				restaurantId: null,
			};
			break;
		case SERVER_CONFIG_BY_RESTAURANT_SUCCESS:
			return {
				...previousState,
				appId: action.payload.appId,
				restaurantId: action.payload.restaurantId,
			};
			break;

		case SET_CURRENT_RESTAURANT:
		case SET_CURRENT_RESTAURANT_FROM_CART:
			return {
				...previousState,
				restaurantId: action.restaurantId,
			};
			break;

		case REPEAT_ORDER_SUCCESS:
			return {
				...previousState,
				restaurantId: action.payload.data.restaurantId
			};
			break;

		default:
			return previousState;
	}
};
